
export default{

    userName(state){
        let name =  state.user ? state.user.username : 'Usuário'
        name = name.split(' ')
        return `${name[0]} ${name.length > 0 ?  name[name.length -1 ].charAt(0).toUpperCase() + '.' : ''} ` 
    },

    usersList(state){
        return state.users_list
    },
    userId(state){
        return state.user ?  state.user.id : null
    },
    isAdmin(state){
        return state.user ? state.user.is_admin : false
    },

    companyId(state){
        return state.user ? state.user.company_id : -1
    },


    visitantFormIsVisible(state){
        return state.visitant.form_is_visible
    }
}